import * as React from 'react';
import { PayPackage as PayPackageComponent } from '../../components/PayPackage/PayPackage';

export const PayPackageContainer = () => {
  return <PayPackageComponent />;
};
